export const hasAccess = (
  allowedPermissions: string[] = [],
  userPermissions: string[] = []
): boolean => {
  if (!Array.isArray(userPermissions)) return false;

  return allowedPermissions.some(
    (perm) =>
      perm === "no-permission-required" || userPermissions.includes(perm)
  );
};
